import React, { useEffect } from 'react';
import Footer from '../Shared/Footer/Footer';
import Navbar from '../Shared/Navbar/Navbar';
import Aos from 'aos';

const Blogs = () => {
    useEffect(() => {
        Aos.init({ duration: 1500 });
    }, [])
    return (
        <section className="container">
            <div>
                <Navbar></Navbar>
            </div>
            <div data-aos="zoom-out-down" className="pt-5 pb-2 text-white text-center">
                <h3>My Bogs</h3>
            </div>
            <div data-aos="zoom-out-up" className="row row-cols-1 row-cols-md-3 g-4 pt-5 pb-5">
                <div className="col">
                    <div className="card">
                        <div className="card-body">
                            <h6 className="card-header">JavaScript Fundamental Concepts</h6>
                            <p className="card-text text">
                                <ul>
                                    <li>In JavaScript, truthy are expressions which evaluates to boolean true value and falsy evaluates to boolean false value. It can have many other forms.</li>
                                    <li>An empty or non existing value is null. It represents a variable whose value is undefined.</li>
                                    <li>If a variable has been declared, but the value of that variable has not been defined then it is undefined.</li>
                                </ul>
                            </p>
                            <a style={{textDecoration: 'none'}} href="https://raisulislam24.medium.com/javascript-fundamental-concepts-27e029078ec0" target="_blank">more...</a>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="card">
                        <div className="card-body">
                            <h6 className="card-header">Everything You Need to Know About React.js</h6>
                            <p className="card-text text">
                                <ul>
                                    <li>React.js is a library for building user interfaces that was first deployed by Facebook in 2011.</li>
                                    <li>JSX stands for JavaScript XML. JSX is very useful feature of React.</li>
                                    <li>The idea of components makes React very powerful. React allows you to break down complex user interfaces into simple components.</li>
                                </ul>
                            </p>
                            <a style={{textDecoration: 'none'}} href="https://raisulislam24.medium.com/everything-you-need-to-know-about-react-js-6258b8e8d0ec" target="_blank">more...</a>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="card">
                        <div className="card-body">
                            <h6 className="card-header">ES6 Basics</h6>
                            <p className="card-text text">
                                <ul>
                                    <li>Hoisting is used for making variables and functions available for use before the variable is assigned a value or the function is defined.</li>
                                    <li>Block-level declarations are the ones that declare variables that are far outside of a given block scope.</li>
                                    <li>For-loop declarations is one of the areas that required block-level variable declarations the most.</li>
                                </ul>
                            </p>
                            <a style={{textDecoration: 'none'}} href="https://raisulislam24.medium.com/es6-basics-552021bee377" target="_blank">more...</a>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <Footer></Footer>
            </div>
        </section>
    );
};

export default Blogs;